export default function WhatsAppIcon({ size = 18, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path
        fill="currentColor"
        d="M16.02 3.2C9.1 3.2 3.48 8.77 3.48 15.61c0 2.2.58 4.34 1.69 6.22L3.36 28.8l7.18-1.83a12.64 12.64 0 0 0 5.48 1.25c6.92 0 12.54-5.57 12.54-12.41S22.94 3.2 16.02 3.2Zm0 22.9c-1.75 0-3.46-.45-4.96-1.31l-.36-.2-4.25 1.08 1.08-4.12-.23-.38a10.15 10.15 0 0 1-1.58-5.56c0-5.66 4.62-10.27 10.3-10.27 5.67 0 10.29 4.61 10.29 10.27S21.69 26.1 16.02 26.1Z"
      />
      <path
        fill="currentColor"
        d="M21.69 18.39c-.31-.15-1.84-.9-2.12-1-.28-.1-.49-.15-.69.15-.2.31-.79 1-.97 1.2-.18.2-.36.23-.67.08-.31-.15-1.31-.48-2.5-1.53-.92-.82-1.55-1.84-1.73-2.15-.18-.31-.02-.48.13-.63.14-.13.31-.36.46-.54.15-.18.2-.31.31-.51.1-.2.05-.38-.03-.54-.08-.15-.69-1.65-.94-2.26-.25-.59-.5-.51-.69-.52h-.59c-.2 0-.54.08-.82.38-.28.31-1.08 1.05-1.08 2.56 0 1.51 1.1 2.97 1.25 3.17.15.2 2.17 3.3 5.25 4.63.73.31 1.3.5 1.75.64.73.23 1.4.2 1.92.12.59-.09 1.84-.75 2.1-1.48.26-.73.26-1.35.18-1.48-.08-.13-.28-.2-.59-.35Z"
      />
    </svg>
  );
}
